import $ from 'jquery'

		var user_journey = {
			init: function() {
				$(window).on('load', this.init_user_journey_stage);
			},
			init_user_journey_stage: function () {

				if (typeof EAPLUS_VARS.post_id === 'undefined') {
					return false;
				}

				var data = {
					action: 'update_user_journey_stage',
					post_id: EAPLUS_VARS.post_id
				};

				$.ajax({
					type: 'POST',
					url: EAPLUS_VARS.ajax_url,
					data: data,
					success: function(response) {},
					dataType: 'html'
				});

				return false;
			}
		};

		var add_coupon = {
			init: function() {
				$(window).on('load', this.init_add_coupon);
			},
			init_add_coupon: function () {

				if (typeof EAPLUS_VARS.ajax_url === 'undefined') {
					return false;
				}

				var urlParams = new URLSearchParams(window.location.search);
				if (urlParams.has('utm_promo')) {
					var utm_promo = urlParams.get('utm_promo');
					var data = {
						action: 'add_utm_promo',
						utm_promo: utm_promo
					};

					$.ajax({
						type: 'POST',
						url: EAPLUS_VARS.ajax_url,
						data: data,
						success: function(response) {},
						dataType: 'html'
					});

				}

				return false;
			}
		};

		var fire_event_tracking = {
			init: function() {
				$(window).on('load', this.init_fire_event_tracking);
			},
			init_fire_event_tracking: function() {

				if (typeof EAPLUS_VARS === 'undefined') {
					return false;
				}

				var data = {
					action: 'fire_tracking_event',
					referral_url: document.location.href,
					is_page: EAPLUS_VARS.is_page,
					is_partner_page: EAPLUS_VARS.is_partner_page,
					is_partner_lander: EAPLUS_VARS.is_partner_lander,
					post_id: EAPLUS_VARS.post_id,
					is_archive: EAPLUS_VARS.is_archive,
					is_search: EAPLUS_VARS.is_search,
					search_query: EAPLUS_VARS.search_query,
					is_cart: EAPLUS_VARS.is_cart,
					is_checkout: EAPLUS_VARS.is_checkout,
					is_order_pay: EAPLUS_VARS.is_order_pay,
					is_order_received: EAPLUS_VARS.is_order_received,
					order_id: EAPLUS_VARS.order_id,
					order_key: EAPLUS_VARS.order_key
				};

				if (EAPLUS_VARS.is_partner_page == true) {
					data.partner_id = EAPLUS_VARS.post_id;
				}

				if (EAPLUS_VARS.is_partner_lander == true) {
					data.partner_id = EAPLUS_VARS.partner_id;
				}

				$.ajax({
					type: 'POST',
					url: EAPLUS_VARS.ajax_url,
					data: data,
					success: function(response) {
						var response = JSON.parse(response);
						window.dataLayer = window.dataLayer || [];
						var data = {
							'event': 'pageview',
							'client': response.client_code,
							'tracking_code': response.tracking_code,
							'discount': response.discount,
							'conversion': response.conversion,
							'journey_stage': response.user_journey_stage
						};
						jQuery.each(response.event, function(index, event) {
							data.event = event;
							if (event == 'site_search') {
								data.search_query = response.search_query;
							}
							if (event == 'purchase') {
								data.conversion = response.conversion;
								data.orderId = response.orderId;
								data.customerId = response.customerId;
								data.customerEmail = response.customerEmail;
								data.customerStatus = "";
								data.currencyCode = "USD";
								data.orderPromoCode = "";
								data.orderDiscount = response.discount;
								data.items = response.items;
								data.value = response.value;
								data.transaction_id = response.transaction_id;
							}
							if (event == 'add_to_cart') {
								data.value = response.value;
								data.items = response.items;
							}
							if (event == 'begin_checkout') {
								data.value = response.value;
								data.items = response.items;
							}
							dataLayer.push(data);
						});
					},
					dataType: 'html'
				});

				return false;

			}
		};

		var update_dynamic_content = {

			init: function() {
				$(window).on('load', this.init_update_dynamic_content);
			},
			init_update_dynamic_content: function() {

				if (typeof EAPLUS_VARS.ajax_url === 'undefined') {
					return false;
				}

				if (EAPLUS_VARS.is_partner_page == true) {
					return false;
				}

				var data = {
					action: 'update_dynamic_content',
				};

				$.ajax({
					type: 'POST',
					url: EAPLUS_VARS.ajax_url,
					data: data,
					success: function (response) {
						if (typeof response === 'string' && response.trim().length != 0) {
							var response = JSON.parse(response);
							if (response.sales_phone_number != false && $('.sales-phone-number').length) {
								$('.sales-phone-number').each(function() {
									$('a.sales-phone-number').attr('href', 'tel:' + response.sales_phone_number);
									$('a.sales-phone-number span.phone-number').html(response.sales_phone_number);
								});
							}
							if (response.customer_service_phone_number != false && $('.customer-service-phone-number').length) {
								$('.customer-service-phone-number').each(function() {
									$('a.customer-service-phone-number').attr('href', 'tel:' + response.customer_service_phone_number);
									$('a.customer-service-phone-number span.phone-number').html(response.customer_service_phone_number);
								});
							}
							if (response.tripinsure_member_center_page_visible == false && $('.process-tripinsure').length) {
								if ($('.tripinsure-block').length) {
									$('.tripinsure-block').hide();
								}
							}
							if (response.tripinsure_support_page_visible == false && $('.process-tripinsure').length) {
								if ($('.tripinsure-block').length) {
									$('.tripinsure-block').hide();
								}
							}
						}
					},
					dataType: 'html'
				});
			}
		};

		var handle_failed_payments = {
			init: function() {
				$(window).on('load', this.init_handle_failed_payments);
			},
			init_handle_failed_payments: function() {

				if (typeof EAPLUS_VARS.is_checkout === 'undefined') {
					return false;
				}

				if (EAPLUS_VARS.is_checkout == true) {

					window.addEventListener('message', function(e) {
						var data = {
							'event': '',
							'client': getCookie('ea_client'),
							'tracking_code': getCookie('ea_tcode'),
							'discount': '',
							'conversion': '',
							'journey_stage': getCookie('user_journey_stage'),
						};
						if (e.data.channel === 'cancelPayment' || e.data.channel === 'handlePaymentErrors') {
							if (e.data.channel === 'cancelPayment') {
								data.event = 'payment_back';
							}
							if (e.data.channel === 'handlePaymentErrors') {
								data.event = 'payment_error';
							}
							window.dataLayer = window.dataLayer || [];
							dataLayer.push(data);
						}

					});

				}
			}
		};

		var run_tests = {

			init: function() {
				$(window).on('load', this.init_run_tests);
			},
			init_run_tests: function() {

				if (typeof EAPLUS_VARS.ajax_url === 'undefined') {
					return false;
				}

				var data = {
					action: 'run_tests',
					is_cart: EAPLUS_VARS.is_cart,
					is_checkout: EAPLUS_VARS.is_checkout,
					plan_addons_page_url: EAPLUS_VARS.plan_addons_page_url
				};

				var urlParams = new URLSearchParams(window.location.search);

				if (urlParams.has('hide_description')) {
					data.hide_description = urlParams.get('hide_description');
				}

				if (urlParams.has('skip_cart')) {
					data.skip_cart = urlParams.get('skip_cart');
				}

				$.ajax({
					type: 'POST',
					url: EAPLUS_VARS.ajax_url,
					data: data,
					success: function(response) {
						if (typeof response === 'string' && response.trim().length != 0) {
							var response = JSON.parse(response);
							if (response.hide_description != false && $('.product-description').length) {
								$('.product-description').each(function() {
									$(this).hide();
								});
							}
							if (response.is_plan_addons_page != false && $('.btn-plan-addons-continue').length) {
								$continue_url = $('.btn-plan-addons-continue').attr('href');
								$cart_url = EAPLUS_VARS.cart_url;
								$('.btn-plan-addons-continue').attr('href', $cart_url);
							}
						}
					},
					dataType: 'html'
				});
			}
		};

		user_journey.init();
		add_coupon.init();
		fire_event_tracking.init();
		update_dynamic_content.init();
		handle_failed_payments.init();
		run_tests.init();

		$(document).on('click', '.partner-update', function(e) {
			e.preventDefault();
			var $thisbutton = $(this);
			const partnerID = $(this).data('partner-id');
			var data = {
				action: 'update_partner',
				partner_id: partnerID,
			};
			$.ajax({
				type: 'POST',
				url: EAPLUS_VARS.ajax_url,
				data: data,
				beforeSend: function(response) {},
				complete: function(response) {},
				success: function (response) {
					if (response.status == 'success') {
						$('a.cart-count span.count').html('0');
						$('#partner-update-modal').modal('hide');
					}
				},
			});
		});

		$(document).on('change', '.select-partner-group', function(e) {
			e.preventDefault();
			var value = $(this).val();
			if (value) {
				var data = {
					action: 'update_partner_group_cookie',
					value: value,
				};
				$.ajax({
					type: 'POST',
					url: EAPLUS_VARS.ajax_url,
					data: data,
					beforeSend: function(response) {},
					complete: function(response) {},
					success: function (response) {
					},
				});
			}
		});

		function getCookie(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
